import React from 'react'
import Toggle from './ThemeToggle'
import TextLogo from '../assets/images/text.png'

const Navbar = () => {
  return (
    <nav className='border-gray-200 mx-2 px-2 py-2.5 rounded ' style={{'backgroundColor': 'transparent !important'}}>
      <div className='container flex flex-row-reverse justify-between items-center mx-auto pt-5'>
        <div className='flex items-center mx-auto'>
          <span className='text-xl font-medium whitespace-nowrap dark:text-white'>
            <img src={TextLogo} style={{'width': '540px', 'maxWidth': '90vw;', 'transform': 'translateX(-282px) !important;'}} />
          </span>
        </div>

        {/* <div className='flex justify-end pr-4'>
          <Toggle />
        </div> */}
      </div>
    </nav>
  )
}

export default Navbar
